import {
  Component,
  Input,
  OnInit,
  AfterViewInit,
  Output,
  EventEmitter,
} from '@angular/core';
import { CookieService } from 'ngx-cookie-service';

import { AuthService } from 'src/app/auth.service';
import { ErrorsService } from 'src/app/services/errors.service';
import { PageService } from 'src/app/services/page.service';
import { CreationalPagesLayoutService } from 'src/app/services/ui/creational-pages-layout.service';
import { UserService } from 'src/app/services/users/users.service';
import { InstitutionService } from 'src/app/services/institutions/institution.service';
import { SearchService } from 'src/app/services/search/search.service';
import { ContentLanguageService } from 'src/app/services/content-language.service';
import { Router } from "@angular/router";

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit, AfterViewInit {
  @Input() user_data: any;
  @Input() questionaries: any[] = [];
  @Input() programs: any[] = [];
  @Output() setQuestionary = new EventEmitter();
  search = '';

  constructor(
    private errorsService: ErrorsService,
    private cookieService: CookieService,
    private userService: UserService,
    private authService: AuthService,
    private pageService: PageService,
    private router: Router,
    private creationalPagesLayoutService: CreationalPagesLayoutService,
    private institutionService: InstitutionService,
    private searchService: SearchService,
    private contentLanguageService: ContentLanguageService,
  ) { }

  ngOnInit(): void {
    this.getUserData();

    this.searchService.searchState$.subscribe(state => {
      const isSearchResultsPage = this.router.url.includes('/dashboard/institution/search-results/');
      if (state.searchTerm && state.searchTerm !== this.search && isSearchResultsPage) {
        this.search = state.searchTerm;
      }
    });
  }

  ngAfterViewInit(): void {
    // setTimeout(() => {
    //   this.tourService.startTour();
    // }, 1500);
  }

  getUserData() {
    const token = this.cookieService.get('gr_access');
    const decode_token = this.authService.getDecodedAccessToken(token);

    this.userService.getUserProfileData(decode_token.user_id).subscribe({
      error: ({ error }) => this.errorsService.handleErrors(error),
      next: (user_data: any) => {
        this.user_data = { ...user_data };

        // Skip organization and questionaries loading for Admin users
        if (this.user_data.user_type === 'Back_Office_Admin') {
          return;
        }

        this.creationalPagesLayoutService.institutionId.next(
          this.user_data.users_organizations[0].organization
        );

        
        // ----------------------------------------------------
        // POSIBLE CODIGO MUERTO
        // ----------------------------------------------------
        // this.getQuestionariesByInstitution();
      },
    });
  }

  onIconClick(action: string): void {
    switch (action) {
      case 'search':
        // Clear persisted search state to show default filters (type: UNIVERSITY)
        this.searchService.clearSearch();
        this.search = '';
        this.router.navigate(['/dashboard/institution/search-results', '']);
        break;
      case 'notification':
        console.log("Se hizo clic en el ícono de notificación.");
        break;
      case 'settings':
        this.router.navigate(['/dashboard/profile']);
        break;
      case 'logout':
        this.logoutHandler()
        break;
      default:
        console.log("Acción no reconocida:", action);
    }
  }

  logoutHandler() {
    const refreshToken = {
      refresh: this.cookieService.get('gr_refresh'),
    };

    const cleanup = () => {
      localStorage.removeItem('brandlogo');
      this.cookieService.delete('gr_access', '/');
      this.cookieService.delete('gr_refresh', '/');

      // Limpiar cachés de servicios
      this.userService.clearUserProfileCache();
      this.userService.clearCurrentUser();
      this.pageService.clearProgramsCache();
      this.institutionService.clearFiltersCache();
      this.searchService.clearSearch();
      this.contentLanguageService.clear();

      this.router.navigate(['/signin'], { replaceUrl: true }).then(() => {
        this.authService.resetLogoutFlag();
      });
    };

    // Llamar al backend primero (necesita las cookies para el header Authorization)
    this.authService.logout(refreshToken).subscribe({
      next: () => cleanup(),
      error: () => cleanup()
    });
  }

  // ----------------------------------------------------
  // POSIBLE CODIGO MUERTO
  // ----------------------------------------------------

  // getQuestionariesByInstitution() {
  //   this.pageService.getPrograms().subscribe({
  //     next: (data: any) => {
  //       const questionaryId = localStorage.getItem('my_questionary');
  //       this.questionaries = data;
  //       if (questionaryId) {
  //         this.questionaries.forEach((questionary) => {
  //           if (questionary.id == questionaryId) {
  //             questionary.selected = true;
  //             this.setQuestionary.emit(questionary);
  //             localStorage.setItem('questionaryData', JSON.stringify(questionary));
  //             console.debug('storaged');
  //           }
  //         });
  //       } else {
  //         this.questionaries[0].selected = true;
  //         this.setQuestionary.emit(this.questionaries[0]);
  //         localStorage.setItem('questionaryData', JSON.stringify(this.questionaries[0]));
  //       }
  //     },
  //     error: (e) => {
  //       this.errorsService.handleErrors(e);
  //     },
  //   });
  // }
}
